export default "__VITE_ASSET__DAzt3h1P__"